import React from "react";
import styled from "styled-components";

interface HeroProps {
  title: string;
  subtitle?: string;
  ctaText?: string;
  onCtaClick?: () => void;
  backgroundImage: string;
}

const HeroContainer = styled.section<{ backgroundImage: string }>`
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: #c2c1c1ad;
    backdrop-filter: brightness(0.7);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  padding: 0 1.5rem;

  h1 {
    font-size: clamp(2rem, 5vw, 4rem);
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
    }
    
  p {
    font-size: clamp(1rem, 2vw, 1.25rem);
    font-weight: 400;
    color: #656e91;
    margin-bottom: 2rem;
  }

  button {
    background-color: #007bff;
    color: white;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #005fcc;
      transform: translateY(-2px);
    }
  }
`;

const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  ctaText,
  onCtaClick,
  backgroundImage,
}) => {
  return (
    <HeroContainer backgroundImage={backgroundImage}>
      <HeroContent>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {ctaText && <button onClick={onCtaClick}>{ctaText}</button>}
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
